module.exports = __webpack_public_path__ + "img/gb5285.prt.8843219e.jpg";